import { Observable } from "rxjs";
import { InjectionToken } from "@angular/core";
import { BaseResponseModel, SelectListItem } from "app/core/models";
import { InterstoreProductRequestDataModel, InterstoreSearchModel, InterstoreSearchProductDataModel, LadgerDataListModel, ProductInventoryDataModel } from "../model";
import { HttpParams } from "@angular/common/http";

export const INTERSTORE_SERVICE = new InjectionToken('interstore service...')

export interface InterstoreInterface {

  getStoreWiseMetaData(styleNo: string): Observable<BaseResponseModel<SelectListItem>>;

  searchProductInInventory(searchModel: InterstoreSearchModel): Observable<BaseResponseModel<ProductInventoryDataModel>>;

  searchProductInterStore(searchModel: InterstoreSearchModel): Observable<BaseResponseModel<InterstoreSearchProductDataModel>>;

  mackToOrderDesing(productHeaderIds: Array<number>): Observable<BaseResponseModel<string>>;

  getLadgerDataList(): Observable<BaseResponseModel<LadgerDataListModel>>;

  downloadLedgerInvoice(ledgerId: number): Observable<BaseResponseModel<LadgerDataListModel>>;

  getProductRequestRecevedList(parameters: HttpParams): Observable<BaseResponseModel<InterstoreProductRequestDataModel>>;

  getProductRequestItemsByRequestId(requestId: number): Observable<BaseResponseModel<InterstoreProductRequestDataModel>>;

  productShipmentStatusById(productId: number): Observable<BaseResponseModel<InterstoreProductRequestDataModel>>;

  updateInterstoreTransferRequestStatus(payload: any): Observable<BaseResponseModel<string>>;

  getInterStoreInvoiceByRequestId(invoiceId: number): Observable<BaseResponseModel<string>>;

  updateInterstoreTransferRequestReceivedStatus(productId: number): Observable<BaseResponseModel<string>>;

  updateInterstoreTransferRequestPaymentStatus(productId: number): Observable<BaseResponseModel<string>>;

  uploadDocument(formData: FormData): Observable<BaseResponseModel<string>>;

  getDocumentDetailsByRequestId(requestId: number): Observable<BaseResponseModel<any>>;
}

